import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import isArray from 'lodash/isArray';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import { useGetMunicipios } from '@/api/get-municipios';
import type { IDropdownOptions, ILocation } from '@/Interfaces/Data';
import { setFilterCityOnDashboard } from '@/_store/modules/filters/slice';
import { KEY_QL_MANAGER_SELECTED_CITY } from '@/_constants/keys';

export const useCities = () => {
  const dispatch = useAppDispatch();
  const { data: cities, isLoading: loadingCities } = useGetMunicipios();
  const selectedCity = useAppSelector(state => state.filters.cityIdOnDashboard);

  const [location, setLocation] = useState<ILocation>();

  const getSelectedCity = () => {
    if (cities?.length) {
      const savedCityOnLocalStorage = localStorage.getItem(
        KEY_QL_MANAGER_SELECTED_CITY,
      );

      const city = savedCityOnLocalStorage
        ? cities?.find(city => city._id == savedCityOnLocalStorage)
        : undefined;

      if (city?._id && city.localizacao) {
        dispatch(setFilterCityOnDashboard(city._id));
        setLocation(city.localizacao);
        return;
      }
      dispatch(setFilterCityOnDashboard(cities?.[0]._id));
      setLocation(cities?.[0].localizacao);
    }
  };

  const saveCityOnLocalStorage = (cityId: string) => {
    localStorage.setItem(KEY_QL_MANAGER_SELECTED_CITY, cityId);
  };

  useEffect(() => {
    if (selectedCity) {
      saveCityOnLocalStorage(selectedCity);
    }
  }, [selectedCity]);

  useEffect(() => {
    getSelectedCity();
  }, [cities]);
  const CITIES_OPTIONS: IDropdownOptions[] = isArray(cities)
    ? cities.map(city => ({
        key: city._id,
        text: `${city.nome.toUpperCase()} - ${city.uf.toUpperCase()}`,
        value: city._id,
      }))
    : [];

  const CITIES_OPTIONS_WITH_ALL = [
    { key: 'TODOS', text: 'TODOS', value: ' ' },
    ...CITIES_OPTIONS,
  ];

  const getCityInfo = (cityId: string) => {
    if (isEmpty(cities)) return null;

    return cities?.find(city => city._id === cityId);
  };

  return {
    CITIES_OPTIONS,
    CITIES_OPTIONS_WITH_ALL,
    cities,
    loadingCities,
    selectedCity,
    location,
    getCityInfo,
  };
};
